import {useMemo} from 'react';
import type {Schema, TypedSchema} from 'schemaDefinition/types';
import type {NationalAgentType} from 'services/agent/types';
import {useAgentSchema} from 'schemas';
import type {NationalAgentWithInEbba} from '../types';

const extraSchemaParts: TypedSchema<NationalAgentWithInEbba> = {
  name: 'nationalAuthorityRegistry',
  parts: [
    {
      name: 'inEbba',
      type: 'bool',
    },
    {
      name: 'registryStatus',
      type: 'text',
    },
  ],
};

export const useNationalRegistryAgentSchema = (
  agentType: NationalAgentType,
): Schema => {
  const agentSchema = useAgentSchema(agentType);
  return useMemo(
    () => ({
      name: extraSchemaParts.name,
      parts: [...extraSchemaParts.parts, ...agentSchema.parts],
    }),
    [agentSchema],
  );
};
